import { CopySimple, DoorOpen, Gear } from "@phosphor-icons/react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLogout } from "src/hooks/API/useLogout";
import { useAccessControl } from "src/routes/context/AccessControl";
import { ModalPassword } from "../Header/components/ModalPassword";
import "./Sidebar.css";

interface INavbar {
  icon?: JSX.Element;
  text: string;
  route: string;
}

interface ISidebarX {
  navbar: INavbar[];
  menuOpen?: boolean;
}

export const SidebarX = ({ navbar, menuOpen }: ISidebarX) => {
  const { acesso, name } = useAccessControl();
  const { mutate } = useLogout();
  const navigate = useNavigate();
  const location = useLocation();

  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [copiedIndex, setCopiedIndex] = useState<number | null>(null);

  const copyTexts = [
    { label: "PIX CNPJ", text: "ab512de6-aa7b-4750-8321-914416061baa" },
    { label: "PIX Aleatório", text: "08878fc2-21ea-4b7f-8379-56986fa350a1" },
    {
      label: "Transferência",
      text: `Não há para Corpx`,
    },
    {
      label: "Envio Final",
      text: `Quiser comprar mais só mandar mensagem \n
Whatsapp: 55+ 12 99254-6355
Telegram: @Tianopo`,
    },
    {
      label: "Compliance",
      text: `Para aceitar a ordem é necessário enviar os documentos: selfie com documento, identidade frente e verso, comprovante de endereço, extrato bancário, comprovante de renda (IRPF, IRPJ, holerite ou outros), para CNPJ enviar mais, contrato social, balancete assinado por contador`,
    },
  ];

  const handleCopy = async (index: number, text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 3000);
    } catch (err) {
      console.error("Falha ao copiar texto", err);
    }
  };

  return (
    <div
      className={`h-calc-header sticky w-60 border-e-1 border-edge-primary bg-white md:flex ${menuOpen ? "flex h-screen" : "hidden"}`}
    >
      <div className={`h-calc-header fixed flex w-60 flex-col justify-between px-2 py-4 md:w-44`}>
        <div>
          {navbar?.map((nav: INavbar, index: number) => (
            <div
              className={`flex h-10 cursor-pointer items-center justify-start gap-2.5 rounded hover:bg-selected-primary hover:text-write-primary ${location.pathname === nav.route ? "bg-selected-primary text-write-primary" : "text-write-secundary"} `}
              key={index}
              onClick={() => navigate(nav.route)}
            >
              {nav.icon}
              <h6>{nav.text}</h6>
            </div>
          ))}
        </div>
        <div className="flex flex-col gap-2">
          <div className="border-edge block border-t-1 md:hidden" />
          <div className="flex flex-col items-center gap-5 md:hidden">
            <div
              className="flex cursor-pointer items-center gap-5 rounded-6 p-2.5 text-write-secundary hover:bg-secundary hover:text-write-primary"
              onClick={(e) => {
                e.stopPropagation();
                setShowPasswordModal(true);
              }}
            >
              <h5>
                <Gear width={19.45} height={20} weight="fill" />
                {name}
              </h5>
            </div>
          </div>
          <ModalPassword isOpen={showPasswordModal} onClose={() => setShowPasswordModal(false)} />

          {/* Botões de cópia visíveis apenas para Master */}
          {acesso === "Master" &&
            copyTexts.map((item, index) => (
              <div
                key={index}
                className="flex h-10 cursor-pointer items-center justify-start gap-2.5 rounded-10 pl-2.5 text-write-secundary hover:bg-selected-primary hover:text-write-primary"
                onClick={() => handleCopy(index, item.text)}
              >
                <CopySimple width={20} height={17} weight="duotone" />
                <h6>{copiedIndex === index ? "Copiado!" : item.label}</h6>
              </div>
            ))}

          <div className="border-edge border-t-1" />
          <div
            className="flex h-10 cursor-pointer items-center justify-start gap-2.5 rounded-10 pl-2.5 text-write-secundary hover:bg-selected-primary hover:text-write-primary"
            onClick={() => mutate()}
          >
            <DoorOpen width={20} height={17} weight="duotone" />
            <h6>Sair</h6>
          </div>
        </div>
      </div>
    </div>
  );
};
